import { Link } from "react-router-dom";
import Elements from "../../assets/svg/elements.svg";
import CodeBlue from "../../assets/svg/code-blue.svg";
import ScrollAnimation from "./animations/ScrollAnimation";

const FormulesHome = () => {
  const Formule = ({
    icon,
    title,
    titleIcon,
    price,
    descriptions,
    buttonLink,
    buttonText,
    additionalInfo,
    className,
  }) => (
    <div className="border border-formule rounded-3xl max-w-[362px] py-7 px-7 flex flex-col justify-between min-h-[540px]"> {/* Hauteur fixe ici */}
      <div>
        <div className="flex justify-between">
          <img
            src={icon}
            alt="icon"
            height={30}
            width={30}
          />
          <p className="px-3 py-2 rounded-lg text-gradient bg-bgFormule">
            {titleIcon}
          </p>
        </div>
        <h3 className="text-[28px] font-bold pt-7">{title}</h3>
        <h2 className="py-11 text-[26px]">{price}</h2>
        <div className="space-y-3">
          {descriptions.map((description, index) => (
            <div
              key={index}
              className="flex items-center gap-x-2 space-y-4 md:space-y-0 text-[12px]">
              <img
                src={description.icon}
                alt="icon"
                height={16}
                width={16}
                className="hidden"
              />
              <p className="pt-4 md:pt-0 text-lg font-medium">{description.text}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-center pt-7">
        <Link to={buttonLink}>
          <button
            className={`text-white bg-gradient-to-r from-gradient to-[#B382E8] py-4 px-5 rounded-[45px] ${className}`}>
            {buttonText}
          </button>
        </Link>
      </div>
      {additionalInfo && (
        <div className="flex items-center gap-x-2 pt-4 text-[12px]">
          <img
            src={additionalInfo.icon}
            alt="icon"
            height={17}
            width={17}
          />
          <p>{additionalInfo.text}</p>
        </div>
      )}
    </div>
  );

  return (
    <section className="px-3 pt-40 mt-40 bg-background md:px-14">
      <div
        className="bg-white px-3 py-10 rounded-[30px] md:py-20 md:px-20 max-w-[1500px] mx-auto"
        id="produits">
        <ScrollAnimation direction="top">
          <div className="space-y-5 md:text-center">
            <h3>Nos solutions</h3>
            <h2>Des formules adaptées à vos besoins</h2>
          </div>
        </ScrollAnimation>
        <div className="flex flex-col pt-16 gap-y-10 md:flex-row md:flex-wrap md:justify-center md:gap-x-4 md:gap-y-10">
          <ScrollAnimation
            direction="left"
            delay={1}>
            <Formule
              icon={Elements}
              title="Design first"
              titleIcon="Design Produit"
              price="1850€* HT"
              descriptions={[
                {
                  text: "Transformez vos concepts en réalité avec notre offre de prototypage rapide.",
                },
              ]}
              buttonLink="design-first"
              buttonText="En savoir plus 👋"
            />
          </ScrollAnimation>

          <ScrollAnimation
            direction="bottom"
            delay={2}>
            <Formule
              icon={CodeBlue}
              title="Site commerciale"
              titleIcon="Commercial"
              price="Sur devis"
              descriptions={[
                {
                  icon: null,
                  text: "Découvrez notre service complet de création de sites commerciaux adaptés à vos besoins",
                },
              ]}
              buttonLink="/start-quickly"
              buttonText="En savoir plus 👋"
            />
          </ScrollAnimation>
          <ScrollAnimation
            direction="right"
            delay={3}>
            <Formule
              icon={CodeBlue}
              title="Offres de conseils & expertises"
              titleIcon="Expertise"
              price="350-500€ / semaines"
              descriptions={[
                {
                  icon: null,
                  text: "Profitez de l'expertise de nos consultants pour dynamiser votre projet avec une approche sur mesure.",
                },
              ]}
              buttonLink="/work-better"
              buttonText="En savoir plus 👋"
              className={"mt-5"}
            />
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
};

export default FormulesHome;
